/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-08-02 14:09:19
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-05-16 12:20:35
 * @FilePath: \community-backende:\sns-user-frontend\src\lang\en-GB\page\template.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  inputText: 'input text',
  cummunityId: 'community id',
  communityName: 'Your Community Name',
  inputError: 'please input',
  chooseError: 'please choose',
  rateError: 'please rate',
  uploadError: 'please upload file',
  flieLimit: 'upload file limit',
  fileSizeLimit: 'upload file size limit',
  files: "{n} File | {n} File | {n} Files",
  chooseFile: 'choose file...',
  countrySelector: 'Select Country',
  needLogin: 'Log in to participate in this activity.',

  fileOversize: 'file limit {n} MB',
  fileOvernum: 'file limit number {n}',
  activeDetail: 'Activity Detail',
  next: 'Next',
  prev: 'Back',
  nextQues: 'Next question',
  prevQues: 'Prev question',
  submit: 'Submit',
  isRequired: 'This is a required question',
  fileOversize: 'File upload limit size {n} MB',
  fileOvernum: 'File upload limit number {n}',
  requirePhoneFormat: 'Phone number format is required',
  uploadFail: 'File upload failed, please try again.',
  fileUploading: 'The file is uploading, please wait a moment.',

  // 抽奖表单
  yourFullName: 'Your Full Name',
  yourPhoneNumber: 'Your Phone Number',
  phoneTips:'Please don’t forget to include the Country code.',
  emailAddress: 'Your Email Address',
  postCode: 'Your Postcode',
  postCodeTips: '',
  remark: 'Additional Notes',
  remarkTips: 'Is there anything else you want us to know?',
  address: 'Your Address',
  addressTips: "Please be thorough with the included details. For example, Indian Members, don't forget your PAN Number.",
  complianceStatement: "The personal information collected on this page is needed to ship the prizes. Refusing to provide this information will prevent you from getting the prize(s), but won’t affect the normal use of other features or services.",
  unagreementText: 'Please inform and agree to the Privacy Statement',
}